import { createContext } from "react";

const publicUser = { isPublic: true };

export const UserContext = createContext(
  localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : publicUser
);
